export default "__VITE_ASSET__34785f42__"